import { PetAttempt } from '../api/mutations/useSubmitPetAttempt'

export const getStepFromData = (
  questionaireData: Partial<PetAttempt>
): 'step-1' | 'step-2' | 'step-3' | 'step-4' => {
  if (
    !questionaireData.name ||
    !questionaireData.kind ||
    !questionaireData.birthDate ||
    !questionaireData.gender
  ) {
    return 'step-1'
  }

  if (
    !questionaireData.breed ||
    !questionaireData.weight ||
    !questionaireData.bodyCondition ||
    (questionaireData.bodyCondition !== 'IDEAL' &&
      questionaireData.weightChangeDesire === undefined) ||
    !questionaireData.activityLevel
  ) {
    return 'step-2'
  }

  if (!questionaireData.email) {
    return 'step-3'
  }

  return 'step-4'
}
